module.exports = __webpack_public_path__ + "img/IDP.13c2e079.svg";